import react from "react";
import OtherHeader from "../header/OtherHeader";
import AuthContext from "../store/auth-context";
import { useContext, useState } from "react";
import "./profile.css";

function Profile() {
  const [newPassword, setNewPassword] = useState("");
  const authCtx = useContext(AuthContext);

  function submitHandler(event) {
    event.preventDefault();
    fetch(
      "https://identitytoolkit.googleapis.com/v1/accounts:update?key=AIzaSyCRmLhkduKgXPMyxhjPHlDXwLwv8AZ4_m8",
      {
        method: "POST",
        body: JSON.stringify({
          idToken: authCtx.token,
          password: newPassword,
          returnSecureToken: false,
        }),
        header: {
          "Content/type": "application/json",
        },
      }
    ).then((res) => {
      if (res.ok) {
        authCtx.setProfile(false);
      }
    });
  }

  function newPass(event) {
    setNewPassword(event.target.value);
  }
  return (
    <>
      {/* <div className="fluid-container bgC">
        <div className="row">
          <div className="col-md-12"> */}
      <OtherHeader></OtherHeader>
      {/* </div>
        </div>
      </div> */}
      <br></br>
      <div className="fluid-container profile">
        <div className="row">
          <div className="col-xl-12 text-center">
            <h2>Welcome {authCtx.email},</h2>
          </div>
        </div>
        <br></br>
        <div className="row">
          <div className="col-xl-2"></div>
          <div className="col-xl-8 text-center">
            <form className="signInForm" onSubmit={submitHandler}>
              <h3>Change Password</h3>
              <br></br>
              <div class="form-group">
                <label for="exampleInputPassword1">New Password</label>
                <input
                  type="password"
                  onChange={newPass}
                  class="form-control emailInput"
                  id="exampleInputPassword1"
                  placeholder="New Password"
                ></input>
              </div>
              <button type="submit" class="btn btn-primary submitChangePass">
                Submit
              </button>
            </form>
          </div>
          <div className="col-xl-2"></div>
        </div>
        {/* <div className="row">
            <div className="col-md-6">
              <Incomes></Incomes>
            </div>
            <div className="col-md-6 expensesBox">
              <Expenses></Expenses>
            </div>
            <div>
              <h3 className="balance ">Balance: ${authCtx.balance}</h3>    
            </div>
          </div> */}
      </div>
    </>
  );
}

export default Profile;
